<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon> menu </mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon> close </mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="goBack()" class="back-btn">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Partidos</span>
</mat-toolbar>

<app-matches-list mode="results"></app-matches-list>

<mat-toolbar class="footer">
  <button mat-raised-button color="primary" (click)="save()">Guardar</button>
</mat-toolbar>

<block-ui></block-ui>
